import { StoryShot } from '../lib/StoryShot';
import { VideoLength, StoryStructure } from '../types';

// Use Vite standard environment variable
const apiKey = import.meta.env.VITE_GEMINI_API_KEY ?? '';

if (!apiKey) {
    console.error("VITE_GEMINI_API_KEY environment variable not set. Please ensure it's configured in your .env.local file.");
}

const storyShot = new StoryShot({ apiKey });

export const generateStoryScript = async (
  topic: string, 
  length: VideoLength, 
  structure: StoryStructure = StoryStructure.HOOK_TO_END
): Promise<string> => {
  if (!apiKey || apiKey === 'your_gemini_api_key_here') {
    return "Error: Gemini API key is not configured. Please set your VITE_GEMINI_API_KEY in the .env.local file.";
  }
  
  try {
    return await storyShot.generateScript(topic, length, structure);
  } catch (error) {
    console.error("Error generating script:", error);
    if (error instanceof Error) {
      return `Error: Failed to generate script. ${error.message}`;
    }
    return "Error: An unknown error occurred while generating the script.";
  }
};


export const generateVideoFromScript = async (script: string): Promise<string> => {
  try {
    return await storyShot.generateVideo(script);
  } catch (error) {
    console.error("Error generating video:", error);
    if (error instanceof Error) {
      throw new Error(`Failed to generate video. ${error.message}`);
    }
    throw new Error("An unknown error occurred while generating the video.");
  }
};